import log from "../log.js";
import { InternalCounterMetricType as CounterMetricType } from "../metrics/types/counter.js";
import { combineIdentifierAndLabel, stripLabel } from "../metrics/types/labeled.js";
export function createLogTag(metric) {
    const capitalizedType = metric.type.charAt(0).toUpperCase() + metric.type.slice(1);
    return `core.metrics.${capitalizedType}`;
}
export function getErrorMetricForMetric(metric, error) {
    const identifier = metric.baseIdentifier();
    const name = stripLabel(identifier);
    return new CounterMetricType({
        name: combineIdentifierAndLabel(error, name),
        category: "glean.error",
        lifetime: "ping",
        sendInPings: metric.sendInPings,
        disabled: false
    });
}
export default class ErrorManager {
    record(metric, error, message, numErrors = 1) {
        const errorMetric = getErrorMetricForMetric(metric, error);
        log(createLogTag(metric), [`${metric.baseIdentifier()}:`, message]);
        if (numErrors > 0) {
            errorMetric.add(numErrors);
        }
    }
    testGetNumRecordedErrors(metric, error, ping) {
        const errorMetric = getErrorMetricForMetric(metric, error);
        const numErrors = errorMetric.testGetValue(ping);
        return numErrors || 0;
    }
}
